import React, { Component } from 'react';
import { motion } from 'framer-motion';
interface WhatsAppButtonProps {
  /** Número en formato internacional sin "+" ni espacios. Ej: 5491122334455 */
  phone?: string;
  /** Mensaje prellenado que se abre en el chat */
  message?: string;
}
export function WhatsAppButton({
  phone = '5493516347235',
  message = 'Hola! Tengo una consulta sobre el Kit Anti-Aburrimiento 🙌'
}: WhatsAppButtonProps) {
  const href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  return <motion.a href={href} target="_blank" rel="noopener noreferrer" aria-label="Escribinos por WhatsApp" initial={{
    opacity: 0,
    scale: 0
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    delay: 1,
    type: 'spring',
    stiffness: 260,
    damping: 20
  }} whileHover={{
    scale: 1.08
  }} whileTap={{
    scale: 0.92
  }} className="fixed bottom-5 right-5 z-50 group flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.45)] hover:shadow-[0_10px_40px_rgba(37,211,102,0.6)] transition-shadow" data-id="element-19">
      {/* Pulso */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" data-id="element-20" />

      {/* Tooltip */}
      <span className="absolute right-full mr-3 hidden md:block whitespace-nowrap bg-slate-900 text-white text-sm font-semibold px-3 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-21">
        ¿Tenés dudas? Escribinos
      </span>

      {/* Ícono oficial de WhatsApp */}
      <svg viewBox="0 0 24 24" className="relative w-7 h-7 md:w-8 md:h-8 fill-current" aria-hidden="true" data-id="element-22">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-23" />
      </svg>
    </motion.a>;
}